<template>
  <v-app id="eign1">
    <v-main>
      <div v-if="!loading">
      <v-container fluid>
      <!-- <v-row>
          <v-col cols="2">
            <v-select v-model="bedrCodesSelected" :items="bedrCodes" item-value="bedrCode"  item-text="bedrCode" label="Companies" multiple></v-select>
          </v-col>
      </v-row> -->
      <v-row>
          <v-col cols="2">
            <v-select v-model="report_params.bedr_codes" :items="bedrCodes" item-value="bedrCode"  item-text="bedrCode" label="Companies" multiple></v-select>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="2">
            <v-select v-model="report_params.inptstatus" :items="inpt_status" item-value="code"  item-text="desc" label="Partner status"></v-select>
          </v-col>
      </v-row>

      <!-- <v-row>    
          <v-col cols="1">
            <v-btn class="primary ma-0" small @click="ovrz">Create excel</v-btn>
          </v-col> 
      </v-row> -->
      <v-row dense class="mt-3">
            <v-col cols="1">
                <btn_create_excel :report_program="report" :report_request="report_request" :report_params="report_params" :show_progress="true" />
            </v-col>
        </v-row>
    </v-container>
    </div>
    </v-main>
    <navBar :title="'Ares - Finance'" :home="true" type="finance"/>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import btn_create_excel from "@/components/ui/buttons/btn_create_excel.vue";
 export default {
  components: {
    navBar,
    btn_create_excel
  },
  data() {
    return {
      bedrCodesSelected: [],
      bedrCodes: [],
      param: {},
      loading: false,
      report: "ares/json/ares/task/fin/exact/excelExportInpt2.p",
      report_params: {
        bedr_codes: [],
        inptstatus: 'Actief'
      },
      report_request: "excelExportInpt2",
      inpt_status: [
        {code: "Actief", desc: "Active"},
        {code: "NietActief", desc: "Not active"},
        {code: "All", desc: "All"}
      ]
    }
  },
  created() {
    var deze = this;
      this.$axios
      .post("ares/json/ares/task/fin/exact/getInpt1Param.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getInpt2Param"
        },
        getInpt1Param: {}
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
           this.param = res.data.getInpt1Param;
           res.data.getInpt1Param.bedrKeuzes.forEach(function(bedr) {
             deze.bedrCodes.push(bedr.bedrCode);
             if (bedr.bedrSelected === true) {
                deze.bedrCodesSelected.push(bedr.bedrCode);      
                deze.report_params.bedr_codes.push(bedr.bedrCode);
             }
           });
        }
      });

  },
  methods: {
     ovrz() {
      this.results = true;
      this.$axios
        .post("ares/json/ares/task/fin/exact/excelExportInpt1.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "excelExportInpt1"
          },
          excelExportInpt1: {
            bedr_codes: this.bedrCodesSelected
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.items = res.data.excelExportInpt1;
            window.open(this.items.filename,'_blank');
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

  }
};

</script> 
